<template lang="pug">
v-dialog(:value="active" max-width="500")
  v-card
    v-card-title.headline.grey.lighten-2(primary-title) {{title}}
    v-card-text {{content}}
    v-divider
    v-card-actions
      v-spacer
      v-btn(color="primary" flat @click="$emit('confirm', $event)") {{confirmText}}
      v-btn(color="secundary" flat @click="$emit('cancel', $event)" v-if="cancelText") {{cancelText}}

</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: 'Aceptar'
    },
    cancelText: String
  }
}
</script>
